import { useMutation } from "@tanstack/react-query";
import {
  createEngagementBlueprint,
  EngagementBlueprintFormData
} from "PFCore/services/admin/engagement_blueprints";

import { mutationKeys } from "./mutation_keys";

export const useEngagementBlueprintCreate = () =>
  useMutation({
    mutationKey: mutationKeys.create(),
    mutationFn: (formData: EngagementBlueprintFormData) => createEngagementBlueprint(formData)
  });
